var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg-upload",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 97",
    style: {
      enableBackground: "new 0 0 96 97"
    },
    xmlSpace: "preserve",
    fill: "#0071B9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48,6.5c-1.062,0-2.08,0.422-2.829,1.172L26.126,26.717c-1.562,1.562-1.562,4.095,0,5.657 c1.562,1.562,4.095,1.562,5.657,0L44,20.157V62.5c0,2.209,1.791,4,4,4s4-1.791,4-4V20.157l12.217,12.217 c1.562,1.562,4.095,1.562,5.657,0c1.562-1.562,1.562-4.095,0-5.657L50.829,7.672C50.08,6.922,49.062,6.5,48,6.5z  M13.5,56.5c-2.209,0-4,1.791-4,4v22c0,3.914,3.185,7.098,7.1,7.098h62.8c3.915,0,7.1-3.184,7.1-7.098v-22c0-2.209-1.791-4-4-4 s-4,1.791-4,4v21.098h-61V60.5C17.5,58.291,15.709,56.5,13.5,56.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.eddd4ea82eee4bf6578f0cd6478c4f97.svg";
export { ForwardRef as ReactComponent };